<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form 
      ref="form" 
      :model="form" 
      :rules="rules" 
      label-width="80px"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item
            label="密码"
            prop="newPassword"
          >
            <el-input 
              type="password"
              v-model="form.newPassword" 
              placeholder="请输入" 
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item
            label="验证密码"
            prop="verifyPassword"
          >
            <el-input 
              type="password"
              v-model="form.verifyPassword" 
              placeholder="请输入" 
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="form-operation">
        <el-col :span="12">
          <el-form-item
            label="操作人"
            class="mb-0"
          >
            <span>{{ parseStrEmpty(form.updateBy) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="操作时间"
            class="mb-0"
          >
            <span>{{ parseStrEmpty(form.updateTime) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { modifyPassword } from '@/api/system/system'
export default {
  data() {
    return {
      form: { 
        userId: '',
        newPassword: '',
        verifyPassword: '',
        typeEnum: '',
      },
      rules: {
        newPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        verifyPassword: [
            { required: true, message: '请输入验证密码', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (value !== this.form.newPassword) {
                  callback(new Error('验证密码不正确，请重新输入'))
                } else {
                  callback()
                }
              }, trigger: 'blur' }
          ]
      }
    }
  },
  methods: {
    getDetails(row, type){
      if(row){
        this.form = {
          userId: row.id,
          typeEnum: type,
          updateBy: row.updateBy || row.createBy,
          updateTime: this.parseTime((row.updateTime || row.createTime), '{y}-{m}-{d} {h}:{i}')
        }
      }
    },
    submit(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let result = await modifyPassword(this.form)
            if(result.code == 200 && result.flag){
              this.$message.success('提交成功')
              resolve()
            }else{
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset(){
      this.form.parentId = null
      this.resetForm('form')
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.deptName,
        children: node.children,
      }
    },
    flatten(arr, key) {
      const res = [] // 结果数组
      arr.forEach((item) => {
        if (item[key]) {
          res.push(item, ...this.flatten(item[key], key)) // 递归
        } else {
          res.push(item)
        }
      })
      return res
    },
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/form.less';
</style>